import US from './US'
import AR from './AR'
import BR from './BR'

export let locales = [
  {
    value: 'US',
    name: 'Inglês Americano',
    native: 'inglês'
  },
  {
    value: 'BR',
    name: 'Brasileiro',
    native: 'português'
  },
  {
    value: 'AR',
    name: 'Espanhol Argentino',
    native: 'argentino'
  }
]

export default {
  US, AR, BR
}


// WEBPACK FOOTER //
// ./resources/assets/js/languages/map.js